import Model from "../Model";

class Comercialsbytype extends Model{

    buildUrl ({ param }) {
        return ['companyview/getgroupbysaletype', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialsbytype;